import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleMenu() {
    $('#book-club-forum-admin-menu').toggle();
  }
}
